import { expT } from '../utils/expenseI18n';

/** Matches backend Expense::PAYMENT_* */
export const EXPENSE_PAYMENT_CASH = 'cash';
export const EXPENSE_PAYMENT_LIPA = 'lipa_number';

export function expensePaymentOptions(lang = 'en') {
  return [
    { value: EXPENSE_PAYMENT_CASH, label: expT(lang, 'exp.payment.cash') },
    { value: EXPENSE_PAYMENT_LIPA, label: expT(lang, 'exp.payment.lipa') },
  ];
}

/** @deprecated use expensePaymentOptions(lang) */
export const EXPENSE_PAYMENT_OPTIONS = expensePaymentOptions('en');

export function expensePaymentLabel(value, lang = 'en') {
  const v = String(value || '').toLowerCase();
  if (v === EXPENSE_PAYMENT_LIPA) return expT(lang, 'exp.payment.lipa');
  return expT(lang, 'exp.payment.cash');
}
